import vue from "../main";

export default class DocumentNumberTemplate {
  constructor() {
    this.id = null;
    this.template_mask = "";
    this.document_type = null;
    this.number_type = null;
    this.template_mask_rules = [() => this.validateTemplateMask()];
    this.document_type_rules = [v => v != null || vue.$t("global.error.required")];
    this.number_type_rules = [v => v != null || vue.$t("global.error.required")];
  }

  load(id, loadUrl = "settings/document-number-template/get") {
    vue.axios.get(loadUrl + "?id=" + id).then(resp => {
      this.id = resp.data.id;
      this.template_mask = resp.data.template_mask;
      this.document_type = resp.data.document_type;
      this.number_type = resp.data.number_type;
    });
  }

  save(saveUrl = "settings/document-number-template/save") {
    return new Promise((resolve, reject) => {
      vue.axios
        .post(saveUrl, this)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }

  validateTemplateMask() {
    let result = [];
    if (
      !(
        this.template_mask.includes("{numer}") ||
        this.template_mask.includes("{NN}") ||
        this.template_mask.includes("{NNN}") ||
        this.template_mask.includes("{NNNN}")
      )
    ) {
      result.push(vue.$t("settings.documentTemplate.numberNotFound"));
    }
    if (this.number_type === 3 || this.number_type === 4) {
      if (!(this.template_mask.includes("{yy}") || this.template_mask.includes("{yyyy}"))) {
        result.push(vue.$t("settings.documentTemplate.yearNotFound"));
      }
    }
    if (this.number_type === 1 || this.number_type === 2) {
      if (!(this.template_mask.includes("{mm}") || this.template_mask.includes("{m}"))) {
        result.push(vue.$t("settings.documentTemplate.monthNotFound"));
      }
    }
    if (this.number_type === 2 || this.number_type === 4 || this.number_type === 6) {
      if (!(this.template_mask.includes("{KRAJ/ZAGR}") || this.template_mask.includes("{Krajowa/Zagraniczna}"))) {
        result.push(vue.$t("settings.documentTemplate.internationalNotFound"));
      }
    }
    return result;
  }
}
